<template>
  <div 
    class="screen-shot-hedan"
    v-bg="`url(${config.screen_shot_bg}) no-repeat 0 0 / 100% auto`"
  >
    <div class="user-wrapper">
      <div 
        class="avatar"
        :style="{
          'border': `border: 1px solid ${config.text_color}`
        }"
      >
        <img v-src="config.user_info.avatar" alt="">
      </div>
      <div 
        class="user-info"
        :style="{
          'color': config.text_color
        }"
      >
        <p class="nickname">{{ config.user_info.username }}</p>
        <p class="user-desc">刚刚在 小黑盒APP 参与了 盒弹{{ config.prize_list.length }}连抽</p>
      </div>
    </div>
    <div class="prize-wrapper">
      <div 
        class="lottery-item-container"
        v-for="(item, index) in config.prize_list"
        :key="index"
      >
        <div 
          class="lottery-item" 
          :class="['color-'+item.rarity]"
        >
          <div class="prize-name">
            <p :style="{'color': config.gc_text_color}">{{item.name}}</p>
          </div>
          <div class="image-box">
            <img v-src="item.img" alt="">
          </div>
          <p class="tag" :style="{'color': config.gc_text_color}">{{ ['', '传说', '史诗', '稀有', '普通'][item.rarity] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../cpt-hedan/assets/css/lottery.less";
// Color variables (appears count calculates by raw css)
@color0: #ffffff; // Appears 14 times
@color1: #fe7f00; // Appears 6 times
@color2: #7a60ff; // Appears 6 times
@color3: #00b1fb; // Appears 6 times
@color4: #46cc76; // Appears 6 times
// Width variables (appears count calculates by raw css)
@width6: 100%; // Appears 25 times

// Height variables (appears count calculates by raw css)
@height3: 100%; // Appears 3 times

.screen-shot-hedan {
  width: 335px;
  padding: 123px 28px 14px;
  .prize-wrapper {
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .lottery-item-container {
      width: 135px;
      height: 90px;
      margin-bottom: 9px;
      .lottery-item {
        transform: scale(0.870967742);
        transform-origin: 0 0;
      }
    }
  }
  .user-wrapper {
    width: 100%;
    height: 32px;
    display: flex;
    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .user-info {
      width: 0;
      flex: 1;
      margin-left: 6px;
      .nickname {
        line-height: 17px;
        font-size: 12px;
        font-weight: 500;
      }
      .user-desc {
        margin-top: 2px;
        line-height: 13px;
        font-size: 9px;
      }
    }
  }
}
</style>